import {
  STEPPER_GLOBAL_OPTIONS,
  StepperSelectionEvent
} from "@angular/cdk/stepper";
import { DecimalPipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subscription, takeUntil, Subject } from "rxjs";
import { CarVariantDialogComponent } from "src/app/share/component/car-variant-dialog/car-variant-dialog.component";
import { INSURER_FULL_NAME } from "src/app/share/constants/common.info";
import {
  PAYMENT_OPTION_EPP,
  PAYMENT_OPTION_EWALLET,
  PAYMENT_OPTION_FP,
  PAYMENT_OPTION_FPX,
  PAYMENT_OPTION_RAZER,
  PAYMENT_OPTION_SHOPBACK,
  PAYMENT_OPTION_VISA,
  PAYMENT_OPTION_ATOME,
  PAYMENT_OPTION_BNPL
} from "src/app/share/constants/payment-options";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { CommonFunction } from "src/app/share/function/common.function";
import { ValidatorFunction } from "src/app/share/function/validator.function";
import {
  D2CQuotationInterface,
  EPPChargeInterface,
  MotorRequestInterface,
  OtherInsurerInterface,
  ProductAddOnInterface,
  ProductDocumentInterface,
  PromoCodeInterface,
  QuotationInterface,
  MotorAddOnCARTPriceInterface,
  BNPLRateListInterface
} from "src/app/share/interface/motor.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { FooterMarginService } from "src/app/share/service/footer-margin.service";
import { PartnerService } from "src/app/share/service/partner.service";
import { ScreenSizeService } from "src/app/share/service/screen-size.service";
import { BenefitDialogComponent } from "../benefit-dialog/benefit-dialog.component";
import { CarDetailsDialogComponent } from "../car-details-dialog/car-details-dialog.component";
import { CarPlanDialogComponent } from "../car-plan-dialog/car-plan-dialog.component";
import { EditQuotationComponent } from "../edit-quotation/edit-quotation.component";
import { SubmitSuccessDialogComponent } from "../submit-success-dialog/submit-success-dialog.component";
import { MotorQuotationDataService } from "src/app/share/data-service/motor/motor-quotation.data.service";
import { MotorQuotationInterface } from "src/app/share/interface/motor-quotation.interface";
import { FieldData } from "src/app/share/interface/common.interface";
import { SignalrService } from "src/app/services/signalr.service";
import { TimerService } from "src/app/share/service/timer.service";
import { LoadingOverlayService } from "src/app/share/service/loading-overlay.service";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: "app-comparison",
  templateUrl: "./comparison.component.html",
  styleUrls: ["./comparison.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    DecimalPipe
  ]
})
export class ComparisonComponent implements OnInit, OnDestroy {
  partnerCode: string = "ps";

  quotationFrmGroup: FormGroup;
  addOnFrmGroup: FormGroup;
  infoFrmGroup: FormGroup;
  agreementFrmGroup: FormGroup;
  paymentFrmGroup: FormGroup;
  paymentFormGroup: FormGroup;

  id: string;
  requestData: MotorRequestInterface;
  quotationList: D2CQuotationInterface[] = [];
  quotationId: string;
  selectedQuotation: QuotationInterface;
  stepperIndex: number = 0;

  @ViewChild("stepper") stepper: MatStepper;

  addOnList: ProductAddOnInterface[] = [];
  fullAddOnList: ProductAddOnInterface[] = [];
  includeAddOnList: ProductAddOnInterface[] = [];
  eppChargeList: EPPChargeInterface[] = [];
  bankInstallmentCharge: { 3: number; 6: number; 12: number };
  bnplRateList: BNPLRateListInterface[] = [];

  addOnOptionalCategory: string[] = [];

  selectedAddOn: ProductAddOnInterface[] = [];

  isFloodChecked: boolean;
  isDriverChecked: boolean;
  showRoadTaxList: boolean = false;
  isIncludeDigitalRoadtax: boolean = false;
  includeDigitalRoadTax: boolean;
  isVBETChecked: boolean;
  isInsurancePlaceholderEnabled: boolean = false;

  subsVar: Subscription;
  paymentTypeChangeSub: Subscription;
  paymentChannelSub: Subscription;

  merwPriceList: number[];
  originalSelectedAddon: any[] = [];

  // Insurance placeholder
  additionalInsurerList = [];
  selectedAdditionalInsurer = [];
  otherInsurerList: OtherInsurerInterface[] = [];
  selectedOtherInsurers: string[] = [];

  // static
  insurerPlaceholderEnabledList = [
    "carsome",
    "wapcar",
    "carlist",
    "grab",
    "ktmb",
    "foodpanda"
  ];
  relationshipList = [
    { id: "Parent/Parent-in-law", name: "common.parents" },
    { id: "Spouse", name: "common.spouse" },
    { id: "Son/Daughter", name: "common.child" },
    { id: "Sibling/Sibling-in-law/Cousin/Relative", name: "common.sibling" },
    { id: "Friend/Co-worker", name: "common.friend" }
  ];
  paymentOptionRazer: string = PAYMENT_OPTION_RAZER;
  paymentOptionShopback: string = PAYMENT_OPTION_SHOPBACK;
  paymentOptionEPP: string = PAYMENT_OPTION_EPP;
  paymentOptionAtome: string = PAYMENT_OPTION_ATOME;
  paymentOptionBNPL: string = PAYMENT_OPTION_BNPL;

  paymentOptionVisa: string = PAYMENT_OPTION_VISA;
  paymentOptionEwallet: string = PAYMENT_OPTION_EWALLET;
  paymentOptionFpx: string = PAYMENT_OPTION_FPX;
  paymentOptionFullPrice: string = PAYMENT_OPTION_FP;
  affiliateBannerData: string[] = [];

  promoCode: string;
  promo: PromoCodeInterface;
  promoError: string;

  stateList: string[] = [
    "Selangor",
    "Wilayah Persekutuan Kuala Lumpur",
    "Wilayah Persekutuan Labuan",
    "Wilayah Persekutuan Putrajaya",
    "Johor",
    "Kedah",
    "Kelantan",
    "Melaka",
    "Negeri Sembilan",
    "Pahang",
    "Perak",
    "Perlis",
    "Pulau Pinang",
    "Sarawak",
    "Sabah",
    "Terengganu"
  ];

  filterStateList: string[] = Object.assign([], this.stateList);
  filterDeliveryStateList: string[] = Object.assign([], this.stateList);

  productDocumentInterface: ProductDocumentInterface[] = [];

  selectedPayment: string = "Razer";
  allowEditQuotation: boolean = false;

  isSameAddressCheck: boolean;
  isDifferentAddressCheck: boolean = false;

  isGrabSingleQuotation: boolean = false;

  otherInsurersList: string[] = [
    "Allianz",
    "am",
    "greateastern",
    "kurnia",
    "liberty",
    "longpac",
    "Msig",
    "Rhb",
    "tokio"
  ];

  uniquePageView: any[] = [
    { index: 0, pageTitle: "comparison page" },
    { index: 1, pageTitle: "add ons page" },
    { index: 2, pageTitle: "user details page" },
    { index: 3, pageTitle: "order summary page" }
  ];

  idTypeList: FieldData[] = [
    { codeValue: "IC_NO", codeDesc: "IC Number" },
    { codeValue: "PASSPORT", codeDesc: "Passport" },
    { codeValue: "POLICE/ARMY", codeDesc: "Police/Army" }
  ];

  cartDayList: FieldData[] = [
    { codeValue: "7", codeDesc: "7" },
    { codeValue: "14", codeDesc: "14" },
    { codeValue: "21", codeDesc: "21" }
  ];

  cartDailyCoverageList: FieldData[] = [
    { codeValue: "50", codeDesc: "RM 50" },
    { codeValue: "100", codeDesc: "RM 100" },
    { codeValue: "200", codeDesc: "RM 200" }
  ];

  maxAdditionalDriver: number;
  maxFreeDriver: number;

  toggleRecommendedAddOnsState: boolean = true;

  numberOfLltpSeats: number = 0;

  isShowGeneraliPaymentConfirmation = false;

  generaliAgreeInfoOne = false;
  generaliAgreeInfoTwo = false;
  generaliAgreeInfoThree = false;

  showMileagePlans: Boolean = false;
  showMileagePlansList: string[] = ["ktmb"];

  maxDob: Date = new Date();

  isMotorcycleAffiliate: Boolean = false;
  isMotorcycleAffiliateList: string[] = ["foodpanda"];

  vehicleAge: number;

  hideVehicleInfoBox: Boolean = false;
  hideVehicleInfoBoxList: string[] = ["foodpanda"];

  cartAddOnPriceList: MotorAddOnCARTPriceInterface[] = [];
  selectedCartDays: string;
  selectedCartDailyCoverage: string;
  minGCKTCoverage: number = 0;
  minVACoverage: number = 0;

  private timerSubscription: Subscription | null = null;
  private timerUnsubscribe$ = new Subject<void>();

  isGeneraliIQ: boolean = false;
  isChubbIQ: boolean = false;
  isTMIMIQ: boolean = false;

  dailyAndAnnual = ["Allianz", "AXA", "Zurich", "Zurich_Takaful", "GrabAXA"];
  annualOnly = ["Sompo"];
  dailyOnly = ["Etiqa", "MSIG", "Chubb", "TMIM"];

  constructor(
    private gtmService: GoogleTagManagerService,
    public translate: TranslateService,
    public screenSizeService: ScreenSizeService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private ngxSpinnerService: NgxSpinnerService,
    public signalRService: SignalrService,
    private partnerService: PartnerService,
    private timerService: TimerService,
    private loadingService: LoadingOverlayService,
    private cd: ChangeDetectorRef,
    private motorDataDataService: MotorDataDataService,
    private router: Router,
    private dialog: MatDialog,
    private motorQuotationService: MotorQuotationDataService,
    private _decimalPipe: DecimalPipe,
    private footerMarginService: FooterMarginService
  ) {
    this.getPartnerCode();
    this.getAdditionalInsurer(activatedRoute.snapshot.params.id);
    this.initConditionalFields();
    this.initQuotationForm();
    this.initAddOnForm();
    this.initInfoForm();
    this.initAgreementForm();
    this.initPaymentFormGroup();

    if (this.isInsurancePlaceholderEnabled) {
      this.signalRService.startConnection().subscribe((isConnected) => {
        this.updateQuotationMethod(isConnected);
      });
    }

    this.id = activatedRoute.snapshot.params.id;

    if (this.isUUID(this.id)) {
      this.allowEditQuotation =
        activatedRoute.snapshot.queryParams.editQuotation;
      this.getDetailById();
    } else {
      window.location.href = "/";
    }
    this.translate.onLangChange.subscribe((x) => {
      if (this.selectQuotation) {
        this.getProductDocument();
      }
    });
    this.gtmService.pushTag({
      event: "car_step1"
    });

    // Unique page view tracking for certain affiliate (Comparison page on render)
    if (
      this.partnerService.getPartnerAttribute(
        this.partnerCode,
        "uniquePageViews"
      )
    ) {
      window.dataLayer.push({
        event: "virtualPageview",
        pageUrl: window.location.href,
        pageTitle: `${this.partnerCode} comparison page`
      });
    }
  }

  public async updateQuotationMethod(isConnected) {
    // Get new updated quotation main method using signalr
    // If connection fail, only call the fallback method (refresh page every 5mins)
    if (isConnected) {
      this.signalRService.receiveUpdatedQuotation().subscribe((message) => {
        this.updateQuotationPrice(message);
        this.getDetailById();
      });
    } else {
      await this.checkIfQuotationExpired();
    }
  }

  private async checkIfQuotationExpired(): Promise<boolean> {
    this.loadingService.setLoading(true);
    let quotation;

    try {
      quotation = await this.motorDataDataService
        .getQuotationById(this.id)
        .toPromise();

      if (quotation.hasOwnProperty("expiredDetails")) {
        this.alertService.openSnackBar("Quotation has expired");
      } else {
        this.quotationList = quotation;
        if (this.partnerCode === "foodpanda" && this.vehicleAge < 11) this.quotationList = quotation.filter(x => x.code !== 'RHB');

        const hasNewQuotation = this.quotationList.some(
          (item) => item.status === "New"
        );

        if (hasNewQuotation) {
          // Start or restart the timer if needed
          this.timerService.startTimer();

          // Ensure only one subscription to the timerExpired$ observable
          if (!this.timerSubscription) {
            this.timerSubscription = this.timerService.timerExpired$
              .pipe(takeUntil(this.timerUnsubscribe$))
              .subscribe(() => {
                // Call the function again after timer expires
                this.checkIfQuotationExpired();
              });
          }
        } else {
          // Stop the timer and clean up subscription if no new quotations
          this.timerService.stopTimer();
          if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
            this.timerSubscription = null;
          }
        }

        this.loadingService.setLoading(false);
        return false;
      }
    } catch (err) {
      this.loadingService.setLoading(false);
      window.location.href = "/";
      return false;
    }

    return true;
  }

  updateQuotationPrice(insurerName) {
    let quotation;
    this.motorDataDataService.getQuotationById(this.id).subscribe((x) => {
      quotation = x;
      this.quotationList = quotation;
      if (this.partnerCode === "foodpanda" && this.vehicleAge < 11) this.quotationList = quotation.filter(x => x.code !== 'RHB');

      this.cd.detectChanges();

      // Stop signalr connection if all quotations are updated
      if (this.isAllQuotationUpdated()) {
        this.signalRService.stopConnection();
      }
    });
  }

  isAllQuotationUpdated(): boolean {
    if (
      this.quotationList.filter(
        (x) => x.status == "New" || x.status == "On-Hold"
      ).length == 0
    )
      return true;
    else return false;
  }

  ngOnInit() {
    this.footerMarginService.updateComponent("ComparisonComponent");
    // Listen for window resize events
    this.screenSizeService.notifyResize();
    window.addEventListener("resize", () =>
      this.screenSizeService.notifyResize()
    );
  }

  ngOnDestroy(): void {
    this.footerMarginService.updateComponent(null);
    this.footerMarginService.updateStepperIndex(null);

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timerUnsubscribe$.next();
    this.timerUnsubscribe$.complete();
  }

  get isInsurerWithoutServiceFee(): boolean {
    return ["AXA", "TMIM"].includes(this.selectedQuotation?.code);
  }

  get isPaymentProviderShopback() {
    return (
      this.paymentFormGroup?.value?.paymentProvider ==
      this.paymentOptionShopback
    );
  }

  get isPaymentTypeEPP() {
    return this.paymentFormGroup?.value?.paymentType == this.paymentOptionEPP;
  }

  get showBankInstallmentCharges() {
    return (
      this.paymentFormGroup?.value?.paymentType == this.paymentOptionEPP &&
      this.paymentFormGroup?.value?.bank &&
      this.paymentFormGroup?.value?.installmentMonth
    );
  }

  get isPaymentTypeBNPL() {
    return this.paymentFormGroup?.value?.paymentType == "BNPL";
  }

  get isPaymentChannelFPX() {
    return (
      this.paymentFormGroup?.value?.paymentChannel == this.paymentOptionFpx
    );
  }

  get isTotalNotNegative() {
    return this.getTotal() >= 0;
  }

  private getPartnerCode() {
    this.partnerCode = this.partnerService.getPartnerCode();
    !this.partnerCode ? (this.partnerCode = "ps") : null;

    if (this.insurerPlaceholderEnabledList.includes(this.partnerCode)) {
      this.isInsurancePlaceholderEnabled = true;
    } else this.isInsurancePlaceholderEnabled = false;
  }

  private initConditionalFields(): void {
    if (this.showMileagePlansList.includes(this.partnerCode)) {
      this.showMileagePlans = true;
    }
    if (this.isMotorcycleAffiliateList.includes(this.partnerCode)) {
      this.isMotorcycleAffiliate = true;
    }
    if (this.hideVehicleInfoBoxList.includes(this.partnerCode)) {
      this.hideVehicleInfoBox = true;
    }
  }

  private initQuotationForm() {
    this.quotationFrmGroup = new FormGroup({
      id: new FormControl(this.quotationId, [Validators.required])
    });
  }

  private initAddOnForm() {
    this.getCARTAddOnPriceList();

    this.addOnFrmGroup = new FormGroup({
      windshield: new FormControl(),
      drivers: new FormArray([]),
      roadTaxPrice: new FormControl(this.requestData?.originalRoadTaxPrice),
      isIncludeRoadtax: new FormControl(),
      isNotBlacklisted: new FormControl(null),
      isWindshieldExceeded: new FormControl(null),
      lltpSeats: new FormControl(this.numberOfLltpSeats[0]),
      merw: new FormControl(),
      cartDays: new FormControl(),
      cartDailyCoverage: new FormControl(),
      gckt: new FormControl(),
      va: new FormControl()
    });

    this.addOnFrmGroup.valueChanges.subscribe(() => {
      this.applyPromoCode();
    });

    this.addOnFrmGroup.controls.isIncludeRoadtax.valueChanges.subscribe((x) => {
      let validators = [];
      let addressValidators = [];
      if (x) {
        validators = [Validators.requiredTrue];
        addressValidators = [Validators.required];
        this.infoFrmGroup.controls.deliveryPostcode.enable();
      } else {
        this.addOnFrmGroup.controls.isNotBlacklisted.reset();
        this.infoFrmGroup.controls.deliveryPostcode.enable();
        if (this.partnerCode == "grab")
          this.addOnFrmGroup.controls.isNotEvp.reset();
      }
      this.addOnFrmGroup.controls.isNotBlacklisted.setValidators(validators);
      this.addOnFrmGroup.controls.isNotBlacklisted.updateValueAndValidity();
      if (this.partnerCode == "grab")
        this.addOnFrmGroup.controls.isNotEvp.setValidators(validators);

      // this.infoFrmGroup.controls.deliveryAddress.setValidators(
      //   addressValidators
      // );
      // this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();

      // this.infoFrmGroup.controls.deliveryAddress2.setValidators(
      //   addressValidators
      // );
      // this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();

      // this.infoFrmGroup.controls.deliveryCity.setValidators(addressValidators);
      // this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();

      // this.infoFrmGroup.controls.deliveryPostcode.setValidators(
      //   addressValidators
      // );
      // this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();

      // this.infoFrmGroup.controls.deliveryState.setValidators(addressValidators);
      // this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
    });
    this.addOnFrmGroup.get("windshield")?.valueChanges.subscribe(() => {
      this.clearPromoCode();
    });

    this.addOnFrmGroup.controls.cartDays.valueChanges.subscribe((x) => {
      if (x) {
        this.selectedCartDays = x;
      }
    });

    this.addOnFrmGroup.controls.cartDailyCoverage.valueChanges.subscribe(
      (x) => {
        if (x) {
          this.selectedCartDailyCoverage = x;
        }
      }
    );
  }

  private initInfoForm() {
    console.log(this.partnerCode);
    this.infoFrmGroup = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      occupation: new FormControl(null, []),
      mobileNo: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      postcode: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      mileage: new FormControl(null, [Validators.required]),
      mileagePhoto: new FormControl([] as File[]),
      lltpSeats: new FormControl(null, []),

      deliveryAddress: new FormControl(null),
      deliveryAddress2: new FormControl(null),
      deliveryCity: new FormControl(null),
      deliveryPostcode: new FormControl(null),
      deliveryState: new FormControl(null)
    });
    this.infoFrmGroup.controls.postcode.disable();

    if (this.partnerCode != "ktmb") {
      // Only required for KTMB
      this.infoFrmGroup.controls.mileage.setValidators([]);
      this.infoFrmGroup.controls.mileage.updateValueAndValidity();
    }

    if (this.showMileagePlans) {
      this.infoFrmGroup.controls.mileagePhoto.setValidators([
        Validators.required,
        Validators.minLength(1)
      ]);
      this.infoFrmGroup.controls.mileagePhoto.updateValueAndValidity();
    }
  }

  private initAgreementForm() {
    this.agreementFrmGroup = new FormGroup({
      agreeInfo: new FormControl(false, [Validators.requiredTrue]),
      doc: new FormArray([])
    });

    if (this.partnerCode === "ktmb") {
      this.agreementFrmGroup.addControl(
        "acknowledge",
        new FormControl(false, [Validators.requiredTrue])
      );
    }
  }

  private initPaymentFormGroup() {
    this.getEppRateList();
    this.getBNPLRateList();

    this.paymentFormGroup = new FormGroup({
      paymentType: new FormControl(this.paymentOptionFullPrice, [
        Validators.required
      ]),
      paymentProvider: new FormControl(this.paymentOptionRazer, [
        Validators.required
      ]),
      paymentChannel: new FormControl("", []),
      ewalletType: new FormControl("", []),
      // For EPP only
      bank: new FormControl("", []),
      installmentMonth: new FormControl(0, []),
      paymentOptionEPPType: new FormControl("", []),
      paymentOptionFPType: new FormControl(this.paymentOptionRazer, [
        Validators.required
      ])
    });

    let paymentFormVal = this.paymentFormGroup.controls;
    let paymentChannel = this.paymentFormGroup.controls.paymentChannel;
    let paymentProvider = this.paymentFormGroup.controls.paymentProvider;
    let ewalletType = this.paymentFormGroup.controls.ewalletType;

    // Change EPP rate on bank change
    this.paymentFormGroup.controls.bank.valueChanges.subscribe((x) => {
      if (x) {
        this.getIndividualEppRates(x);
      }
    });

    // To toggle e-wallet dropdown to be required/not
    this.paymentChannelSub =
      this.paymentFormGroup.controls.paymentChannel.valueChanges.subscribe(
        (x) => {
          if (x == this.paymentOptionEwallet) {
            ewalletType?.setValidators([Validators.required]);
          } else {
            ewalletType?.setValidators([]);
          }
          ewalletType?.updateValueAndValidity();
        }
      );

    // To toggle other payment type child inputs to be required/not
    this.paymentTypeChangeSub =
      this.paymentFormGroup.controls.paymentType.valueChanges.subscribe((x) => {
        if (x == this.paymentOptionFullPrice) {
          paymentChannel.setValidators([]);
          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionRazer
          });
          paymentFormVal?.paymentOptionFPType.setValidators([
            Validators.required
          ]);
        } else {
          paymentChannel.setValidators([]);
        }

        if (x == this.paymentOptionEPP) {
          paymentFormVal?.bank.setValidators([Validators.required]);
          paymentFormVal?.installmentMonth.setValidators([Validators.required]);
          paymentProvider.setValidators([Validators.required]);
          paymentFormVal?.paymentOptionEPPType.setValidators([
            Validators.required
          ]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);
          paymentFormVal.ewalletType.reset();
          paymentFormVal.paymentChannel.reset();

          this.paymentFormGroup.patchValue({
            paymentOptionFPType: "",
            bank: "",
            installmentMonth: ""
          });
        } else {
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionEPPType.setValidators([]);
          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.paymentOptionEPPType.reset();
        }

        if (x == this.paymentOptionShopback) {
          paymentChannel.setValidators([]);
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);

          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.ewalletType.reset();

          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionShopback,
            paymentChannel: this.paymentOptionShopback,
            paymentOptionFPType: ""
          });
        }

        if (x == this.paymentOptionBNPL) {
          paymentChannel.setValidators([]);
          paymentFormVal?.bank.setValidators([]);
          paymentFormVal?.installmentMonth.setValidators([]);
          paymentFormVal?.paymentOptionFPType.setValidators([]);
          paymentFormVal.bank.reset();
          paymentFormVal.installmentMonth.reset();
          paymentFormVal.ewalletType.reset();
          this.paymentFormGroup.patchValue({
            paymentProvider: this.paymentOptionAtome,
            paymentChannel: this.paymentOptionAtome,
            bank: "",
            installmentMonth: "",
            paymentOptionEPPType: "",
            ewalletType: "",
            paymentOptionFPType: ""
          });
        }

        paymentChannel.updateValueAndValidity();
        paymentFormVal?.bank.updateValueAndValidity();
        paymentFormVal?.installmentMonth.updateValueAndValidity();
      });
  }

  private getEppRateList(promoCodeId: string = null) {
    this.motorDataDataService.getEPPRates(promoCodeId).subscribe({
      next: (x: EPPChargeInterface[]) => {
        this.eppChargeList = x;

        // Check if eppRate in the first object is 0
        if (
          this.eppChargeList.length > 0 &&
          this.eppChargeList[0].eppRate === 0
        ) {
          this.affiliateBannerData = ["carsome"]; // Set to ["carsome"] if eppRate is 0
        } else {
          this.affiliateBannerData = []; // Set to an empty array if eppRate is not 0
        }
      }
    });
  }

  private getBNPLRateList() {
    this.motorDataDataService
      .getBNPLRateListByPortal(this.partnerCode)
      .subscribe({
        next: (x: BNPLRateListInterface[]) => {
          this.bnplRateList = x;
        }
      });
  }

  getEppRate() {
    let bankName = this.paymentFormGroup?.value?.bank;
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;
    let installmentPeriod = this.paymentFormGroup?.value?.installmentMonth;

    if (bankName && installmentPeriod && this.eppChargeList?.length) {
      const result = this.eppChargeList?.filter(
        (entry) =>
          entry.bankName == bankName &&
          entry.installmentPeriod == installmentPeriod &&
          entry.provider == paymentProvider
      );
      return result.length > 0 ? result[0]?.eppRate : null;
    } else {
      return null;
    }
  }

  getIndividualEppRates(x) {
    let bankName = x;
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;

    if (bankName && this.eppChargeList?.length) {
      const results: any = this.eppChargeList
        .filter(
          (entry) =>
            entry.bankName == bankName && entry.provider == paymentProvider
        )
        .reduce((accumulator, entry) => {
          const periods = [3, 6, 12];
          if (periods.includes(entry.installmentPeriod)) {
            accumulator[entry.installmentPeriod] =
              entry.eppRate * (this.getTotalCharge() - this.getTotalPromo());
          }
          return accumulator;
        }, {});

      this.bankInstallmentCharge = results;
    } else {
      this.bankInstallmentCharge = { 3: null, 6: null, 12: null };
    }
  }

  private isUUID(uuid: string) {
    return uuid.match(
      "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
    );
  }

  goTo(url: string) {
    window.open(url, "_");
  }

  private getDetailById() {
    this.motorDataDataService.getDetailById(this.id).subscribe({
      next: (x) => {
        this.translate.use(x.language);
        this.requestData = x;
        this.vehicleAge = new Date().getFullYear() - parseInt(this.requestData.year);
        this.addOnFrmGroup.controls.roadTaxPrice.setValue(
          x?.originalRoadTaxPrice
        );
        this.getQuotation();
        this.infoFrmGroup.controls.name.setValue(x.name);
        this.infoFrmGroup.controls.email.setValue(x.email);
        this.infoFrmGroup.controls.mobileNo.setValue(x.mobileNo);
        this.infoFrmGroup.controls.postcode.setValue(x.postcode);
        this.numberOfLltpSeats = x.seat;
        if (this.numberOfLltpSeats <= 4) {
          this.numberOfLltpSeats = 5;
        }
        this.infoFrmGroup.controls.lltpSeats.setValue(this.numberOfLltpSeats);
        this.addOnFrmGroup.controls.lltpSeats.setValue(x.seat);
      },
      error: () => {
        window.location.href = "/";
      }
    });
  }

  private getQuotation() {
    this.motorDataDataService
      .getQuotationById(this.id, this.partnerCode === "ktmb")
      .subscribe({
        next: (x: any) => {
          this.quotationList = x;
          if (this.partnerCode === "foodpanda" && this.vehicleAge < 11) this.quotationList = x.filter(x => x.code !== 'RHB');

          if (this.activatedRoute.snapshot.queryParams.id) {
            setTimeout(() => {
              this.selectQuotation(this.activatedRoute.snapshot.queryParams.id);
            }, 100);
          }
          if (this.allowEditQuotation) {
            this.editQuotation();
            this.allowEditQuotation = false;
          }
          // Set grab ehailing condition
          this.setGrabSingleQuotationCondition();
        },
        error: () => {
          window.location.href = "/";
        }
      });
  }

  private getAdditionalInsurer(id: string) {
    this.motorDataDataService.getAvailableProduct(id).subscribe({
      next: (x: OtherInsurerInterface[]) => {
        this.otherInsurerList = x;
        if (this.partnerCode === "foodpanda" && this.vehicleAge < 11) this.otherInsurerList = x.filter(x => x.code !== 'RHB');
      },
      error: () => {
        // window.location.href = "/";
      }
    });
  }

  private setGrabSingleQuotationCondition() {
    if (
      this.requestData.eHailingUsed &&
      this.partnerCode == "grab" &&
      this.quotationList.some((x) => x.code === "GrabAXA") &&
      this.quotationList.length == 1
    ) {
      this.isGrabSingleQuotation = true;
    } else {
      this.isGrabSingleQuotation = false;
    }
  }

  private getAddOn() {
    this.includeAddOnList = [];
    this.motorDataDataService.getAddOn(this.id, this.quotationId).subscribe({
      next: (x) => {
        this.addOnList = x;

        let vehicleAge: number =
          new Date().getFullYear() - parseInt(this.requestData.year);

        if (vehicleAge > 10 && this.selectedQuotation.name === "Generali") {
          this.addOnList = this.addOnList.filter(
            (obj) => obj.code !== "EHailing"
          );
        }

        if (this.addOnList) {
          this.sortDriversAddonSequence();
        }
        if (this.partnerCode == "ps" && this.toggleRecommendedAddOnsState) {
          this.filterRecommendedAddOns();
        }
        this.fullAddOnList = x;
        this.addOnOptionalCategory = [
          ...new Set(
            this.addOnList.filter((y) => !y.included).map((z) => z.category)
          )
        ];
        this.addOnList.forEach((y) => {
          if (this.partnerCode == "ps" && this.toggleRecommendedAddOnsState) {
            if (y.category == "Windshield" || y.category == "Flood") {
              this.selectedAddOn.push(y);
            }
          }
          if (y.category == "Windshield") {
            this.addOnFrmGroup.controls.windshield.setValue(
              this.getMinMaxWindscreenPrice(y, "min")
            );
          }

          if (y.code == "AdditionalDrivers") {
            this.maxAdditionalDriver = this.getRule(y)?.max ?? null;
            this.maxFreeDriver = !y.condition
              ? this.getRule(y)?.max ?? null
              : null;
          }

          if (y.code == "EHailing" && this.isGrabSingleQuotation) {
            this.selectedAddOn.push(y);
          }

          if (y.code == "MERW") {
            this.merwPriceList = eval(y.evaluate);
            if (this.merwPriceList)
              this.addOnFrmGroup.controls.merw.setValue(this.merwPriceList[0]);
          }

          if (y.category == "CART") {
            this.selectedCartDays = this.cartDayList[0].codeValue;
            this.selectedCartDailyCoverage =
              this.cartDailyCoverageList[0].codeValue;
            this.addOnFrmGroup.controls.cartDays.setValue(
              this.selectedCartDays
            );
            this.addOnFrmGroup.controls.cartDailyCoverage.setValue(
              this.selectedCartDailyCoverage
            );
          }

          if (y.category == "GCKT") {
            this.minGCKTCoverage = this.getRule(y)?.min ?? null;
            this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
          }

          if (y.category == "VA") {
            this.minVACoverage = this.getRule(y)?.min ?? null;
            this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
          }

          if (y.included) {
            this.includeAddOnList.push(y);
            this.selectedAddOn.push(y);
          }
        });
      },
      error: () => {
        window.location.href = "/";
      }
    });
  }

  sortDriversAddonSequence() {
    // Define the custom order for specific codes
    const order = ["UnlimitedDrivers", "AdditionalDrivers"];

    this.addOnList.sort((a, b) => {
      // Handle custom sorting logic
      const indexA = order.indexOf(a.code);
      const indexB = order.indexOf(b.code);

      if (indexA > -1 && indexB > -1) {
        return indexA - indexB; // Both are in the order list
      } else if (indexA > -1) {
        return -1; // a should come before b
      } else if (indexB > -1) {
        return 1; // b should come before a
      } else {
        return 0; // Default sorting for other items
      }
    });
  }

  private getProductDocument() {
    if (!this.selectedQuotation) return;
    this.productDocumentInterface = [];
    let frmArray = this.getAgreeFormArray();
    frmArray.clear();
    this.motorDataDataService
      .getProductDocumentById(
        this.selectedQuotation.productId,
        this.translate.currentLang,
        this.requestData.insuranceType
      )
      .subscribe({
        next: (x) => {
          this.productDocumentInterface = x;
          x.forEach((doc) => {
            if (doc.neededUserAgree) {
              let frm = this.formBuilder.group({
                checked: new FormControl(false, [Validators.requiredTrue]),
                name: new FormControl(doc.name),
                url: new FormControl(doc.url)
              });
              frmArray.push(frm);
            }
          });
        }
      });
  }

  private promoCheck() {
    if (!this.promo) return;
    if (
      this.promo.customCode == "RoadTaxDelivery" &&
      !this.addOnFrmGroup.value.isIncludeRoadtax
    ) {
      this.promo = null;
      this.promoError = "InvalidPromoCode";
    }
  }

  onStepChange(e: StepperSelectionEvent) {
    this.updateStepperIndex(e.selectedIndex);
    this.gtmService.pushTag({
      event: "car_step" + (e.selectedIndex + 1)
    });
    if (this.originalSelectedAddon.length === 0) {
      this.originalSelectedAddon.push(
        ...this.selectedAddOn.map((addOn) => ({ ...addOn }))
      );
    }

    if (e.selectedIndex == 3) {
      let value = this.infoFrmGroup.getRawValue();
      if (
        (this.addOnFrmGroup.value?.isIncludeRoadtax &&
          this.isSameAddressCheck) ||
        (this.addOnFrmGroup.value?.isIncludeRoadtax &&
          !this.isDifferentAddressCheck)
      ) {
        this.infoFrmGroup.controls.deliveryAddress.setValue(value.address);
        this.infoFrmGroup.controls.deliveryAddress2.setValue(value.address2);
        this.infoFrmGroup.controls.deliveryCity.setValue(value.city);
        this.infoFrmGroup.controls.deliveryPostcode.setValue(value.postcode);
        this.infoFrmGroup.controls.deliveryState.setValue(value.state);
      } else if (!this.addOnFrmGroup.value?.isIncludeRoadtax) {
        this.infoFrmGroup.controls.deliveryAddress.reset();
        this.infoFrmGroup.controls.deliveryAddress2.reset();
        this.infoFrmGroup.controls.deliveryCity.reset();
        this.infoFrmGroup.controls.deliveryPostcode.reset();
        this.infoFrmGroup.controls.deliveryState.reset();

        this.infoFrmGroup.controls.deliveryAddress.setValidators([]);
        this.infoFrmGroup.controls.deliveryAddress2.setValidators([]);
        this.infoFrmGroup.controls.deliveryCity.setValidators([]);
        this.infoFrmGroup.controls.deliveryPostcode.setValidators([]);
        this.infoFrmGroup.controls.deliveryState.setValidators([]);

        this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
        this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
        this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
        this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
        this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
      }
    }
    if (e.selectedIndex == 1 || e.selectedIndex == 2) this.applyPromoCode();

    // Unique page view tracking for certain affiliate
    if (
      this.partnerService.getPartnerAttribute(
        this.partnerCode,
        "uniquePageViews"
      )
    ) {
      this.uniquePageView.forEach((x) => {
        if (e.selectedIndex == x.index) {
          window.dataLayer.push({
            event: "virtualPageview",
            pageUrl: window.location.href,
            pageTitle: `${this.partnerCode} ${x.pageTitle}`
          });
        }
      });
    }

    // Recalculate premiums when customer navigate from Add On page to Personal Details page
    //  - applied for: Chubb, Generali and TMIM
    if (
      (this.isChubbIQ || this.isGeneraliIQ || this.isTMIMIQ) &&
      e.previouslySelectedIndex === 1
    ) {
      this.recalculateInstantQuotationPricing();
    }
    if (
      this.selectedQuotation.code === "TMIM" &&
      e.previouslySelectedIndex === 2 &&
      e.selectedIndex === 1
    ) {
      this.selectedAddOn = this.originalSelectedAddon.map((addOn) => ({
        ...addOn
      }));
    }
  }

  recalculateInstantQuotationPricing() {
    // Recalculate premiums is required for IQ due to addons (extra coverages)
    //  - when user selected 1 or more addons, the premiums for the addons will be retrieved from API
    //  - this function mainly reset the 'evaluate' with premiums calculated from API for the addon
    this.loadingService.setLoading(true);
    const handleResponse = {
      next: (x: any) => {
        this.selectedAddOn = x;
        // Sync evaluate values from this.selectedaddon to this.selectedaddontodisplay
        this.selectedAddOn.forEach((displayItem) => {
          const matchingItem = this.selectedAddOn.find(
            (addOn) => addOn.id === displayItem.id
          );
          if (matchingItem) {
            displayItem.evaluate = matchingItem.evaluate;
          }
        });
        this.loadingService.setLoading(false);
      },
      error: () => {
        this.alertService.openSnackBar(
          "Premium calculation failed, please contact Policy Street."
        );
        this.loadingService.setLoading(false);
        this.stepper.selectedIndex = 1;
      }
    };

    if (this.isTMIMIQ) {
      let driverCount = 0;
      if (this.selectedAddOn.some((i) => i.insurerCustomCode === "E303")) {
        driverCount =
          (this.addOnFrmGroup.get("drivers") as FormArray)?.length ?? 0;
      }
      this.motorDataDataService
        .getTMIMQuotationPricing(
          this.selectedAddOn,
          this.addOnFrmGroup.value.windshield,
          this.quotationId,
          driverCount
        )
        .subscribe(handleResponse);
    } else if (this.isChubbIQ) {
      this.motorDataDataService
        .getChubbQuotationPricing(
          this.quotationId,
          this.selectedAddOn,
          this.addOnFrmGroup.value.windshield
        )
        .subscribe(handleResponse);
    } else if (this.isGeneraliIQ) {
      this.motorDataDataService
        .getGeneraliQuotationPricing(
          this.quotationId,
          this.selectedAddOn,
          this.addOnFrmGroup.value.drivers,
          this.addOnFrmGroup.value.windshield,
          this.addOnFrmGroup.value.gckt,
          this.addOnFrmGroup.value.cartDays,
          this.addOnFrmGroup.value.cartDailyCoverage
        )
        .subscribe(handleResponse);
    }
  }

  updateStepperIndex(index: number): void {
    this.footerMarginService.updateStepperIndex(index);
  }

  applyPromoCode() {
    if (!this.promoCode) return;
    this.ngxSpinnerService.show();
    this.promoError = null;
    this.promo = null;

    let quotationId = null;

    // Send quotationId if carsome affiliate, (to not allow promocode if x logic)
    if (this.partnerCode == "carsome") {
      quotationId = this.selectedQuotation.id;
    }

    this.motorDataDataService
      .applyPromoCode(
        this.id,
        this.promoCode,
        "",
        "",
        this.getGrossPremium(),
        quotationId
      )
      .subscribe({
        next: (x) => {
          this.promo = x;
          this.ngxSpinnerService.hide();
          this.promoCheck();

          if (this.promo) {
            this.getEppRateList(this.promo.id);
          }
        },
        error: (err) => {
          this.ngxSpinnerService.hide();
          this.promoError = err.error.message;
        }
      });
  }

  clearPromoCode() {
    this.promoCode = null;
    this.promoError = null;
    this.promo = null;
    this.getEppRateList();
  }

  getFormArray() {
    return this.addOnFrmGroup.get("drivers") as FormArray;
  }

  getAgreeFormArray() {
    return this.agreementFrmGroup.get("doc") as FormArray;
  }

  addDriver() {
    let frmArray = this.getFormArray();
    let form = this.formBuilder.group({
      name: [null, Validators.required],
      idType: [this.idTypeList[0].codeValue, Validators.required],
      identityNo: [
        null,
        [Validators.required, ValidatorFunction.nricValidator()]
      ],
      dob: [null, Validators.required],
      gender: ["M", Validators.required],
      maritalStatus: ["Single", Validators.required],
      relationship: [null, Validators.required],
      isMalaysian: [true]
    });

    form.get("idType").valueChanges.subscribe((value) => {
      if (value === "IC_NO") {
        form
          .get("identityNo")
          .setValidators([
            Validators.required,
            ValidatorFunction.nricValidator()
          ]);
      } else {
        form.get("identityNo").setValidators(Validators.required);
      }

      if (["IC_NO", "POLICE/ARMY"].includes(value)) {
        form.get("isMalaysian").patchValue(true);
      } else {
        form.get("isMalaysian").patchValue(false);
      }

      form.get("identityNo").reset();
      form.get("identityNo").updateValueAndValidity();
    });

    form.get("identityNo").valueChanges.subscribe((value) => {
      if (
        form.get("identityNo").invalid &&
        form.get("idType").value === "IC_NO"
      ) {
        form.get("dob").reset();
      }

      if (
        form.get("identityNo").valid &&
        form.get("idType").value === "IC_NO"
      ) {
        let date = moment(value.substring(0, 6), "YYMMDD");
        let lastChar = value.substring(11);
        let gender = lastChar % 2 ? "M" : "F";

        if (moment().isBefore(date)) {
          date.subtract(100, "year");
        }
        form.patchValue({
          dob: date.toDate(),
          gender: gender
        });
      }
    });

    frmArray.push(form);
  }

  deleteDriver(i: number) {
    let frmArray = this.getFormArray();
    frmArray.removeAt(i);
  }

  selectQuotation(id: string) {
    let lastQuotationId = this.quotationId;
    this.quotationFrmGroup.controls.id.setValue(id);
    this.quotationId = id;
    this.selectedQuotation = this.quotationList.find((x) => x.id == id);
    this.router.navigate([], {
      queryParams: {
        id: id,
        partnerCode: this.partnerCode
      }
    });
    if (this.addOnList.length == 0) this.getAddOn();
    else if (lastQuotationId != this.quotationId) {
      this.addOnList = [];
      this.initAddOnForm();
      this.getAddOn();
      this.selectedAddOn = [];
      this.isDriverChecked = false;
      this.isFloodChecked = false;
      this.isVBETChecked = false;
    }
    this.getProductDocument();
    this.stepper.next();

    this.isGeneraliIQ =
      this.selectedQuotation.name == "Generali" &&
      this.selectedQuotation.isInstantQuotation;
    this.isChubbIQ =
      this.selectedQuotation.name == "Chubb" &&
      this.selectedQuotation.isInstantQuotation;
    this.isTMIMIQ =
      this.selectedQuotation.name == "Tokio Marine" &&
      this.selectedQuotation.isInstantQuotation;

    // Generali's CART does not have RM 200 options
    if (this.isGeneraliIQ) {
      this.cartDailyCoverageList = this.cartDailyCoverageList.filter(
        (x) => parseInt(x.codeValue) < 200
      );
    }
  }

  editQuotation() {
    let dialogRef = this.dialog.open(EditQuotationComponent, {
      data: {
        id: this.id,
        request: this.requestData,
        quotationList: this.quotationList,
        grabSingleQuotation:
          this.partnerCode == "grab" &&
          this.requestData.eHailingUsed &&
          this.quotationList.length == 1
            ? true
            : false
      },
      panelClass: "edit-quote-dialog"
    });

    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.dialog.open(SubmitSuccessDialogComponent, {
          data: {
            editQuotations: true
          },
          panelClass: "success-dialog"
        });
      }
    });
  }

  // -- Other insurer section
  updateSelectedInsurers(id: string) {
    const index = this.selectedOtherInsurers.indexOf(id);
    if (index === -1) {
      this.selectedOtherInsurers.push(id);
    } else {
      this.selectedOtherInsurers.splice(index, 1);
    }
  }

  submitOtherInsurer() {
    let typeOfSum = this.requestData.typeOfSum ?? "MV";

    this.motorQuotationService
      .submitExtraProduct(this.id, typeOfSum, this.selectedOtherInsurers)
      .subscribe({
        next: (x) => {
          this.handleSuccessSubmitQuotation({
            preferredChannel: this.requestData?.preferredChannel,
            email: this.requestData.email,
            mobileNo: this.requestData.mobileNo
          });
        }
      });
  }
  // -- Other insurer section

  get hideStepperLabel() {
    return this.stepper?.selectedIndex === 0 &&
      this.isInsurancePlaceholderEnabled
      ? "hide-stepper"
      : "";
  }

  get sortedQuotationList() {
    return this.quotationList.sort((a, b) => {
      if (a.status === "New" && b.status !== "New") {
        return -1; // "New" always on top
      }
      if (a.status !== "New" && b.status === "New") {
        return 1; // Place "New" above others
      }
      if (a.status === "Rejected" && b.status !== "Rejected") {
        return -1; // "Rejected" comes after "New" but before others
      }
      if (a.status !== "Rejected" && b.status === "Rejected") {
        return 1; // Place "Rejected" below "New"
      }
      return 0;
    });
  }

  get disableEditQuotationBtn() {
    const availableCount = this.quotationList.filter(
      (x) => x.status == "Available"
    ).length;
    return availableCount == 0;
  }

  private handleSuccessSubmitQuotation(
    customerInput: Partial<MotorQuotationInterface>
  ): void {
    const dialogRef = this.dialog.open(SubmitSuccessDialogComponent, {
      panelClass: "success-dialog",
      data: { customerInput }
    });

    dialogRef.afterClosed().subscribe(() => location.reload());
  }

  carDetails() {
    let dialogRef = this.dialog.open(CarDetailsDialogComponent, {
      data: this.requestData
    });

    dialogRef.afterClosed().subscribe((x) => {});
  }

  carPlan() {
    let dialogRef = this.dialog.open(CarPlanDialogComponent, {
      data: this.requestData
    });

    dialogRef.afterClosed().subscribe((x) => {});
  }

  getAddOnListByCategory(val: string) {
    return this.addOnList.filter((x) => x.category == val);
  }

  isAddOnSelected(item: ProductAddOnInterface) {
    if (item) {
      return this.selectedAddOn.some((x) => x.id == item.id);
    }

    return null;
  }

  getPrice(item: ProductAddOnInterface, val?: any) {
    try {
      let evaluate = item.evaluate;
      let customEvaluate = item.customEvaluate;
      let condition = item.condition;

      if (val) {
        evaluate = evaluate.replace("{val}", val);

        if (condition) {
          condition = condition.replace("{val}", val);
          if (item.isConditionFirst) {
            let status = Boolean(eval(condition));
            if (status) {
              return eval(evaluate);
            } else {
              return 0;
            }
          }
        }
      }

      if (
        item.customCode === "Generali_UnlimitedDrivers" &&
        this.selectedAddOn.some((x) => x.code === "Flood")
      ) {
        evaluate = customEvaluate.replace("{val}", val);
      }

      if (item.category === "CART") {
        const cartPrice = this.cartAddOnPriceList.filter(
          (x) =>
            x.days.toString() == this.selectedCartDays &&
            x.coverage.toString() == this.selectedCartDailyCoverage
        );
        evaluate = cartPrice.length > 0 ? cartPrice[0]?.price.toString() : null;
      }

      return eval(evaluate);
    } catch {
      return 0;
    }
  }

  toggleAddOn(e: MatCheckboxChange) {
    let value: ProductAddOnInterface = e.source.value as any;
    if (e.checked) {
      if (value.code === "EHailing") {
        this.toggleAddonPlanCard("none", "roadTaxRenewalClass");
      }
      if (value.category === "LLTP") {
        this.addOnFrmGroup.controls.lltpSeats.setValue(this.numberOfLltpSeats);
      }
      if (value.category === "Windshield") {
        if (
          (this.selectedQuotation.code == "Zurich" ||
            this.selectedQuotation.code == "Zurich_Takaful") &&
          !this.requestData.isCompany
        ) {
          this.addOnFrmGroup.controls.isWindshieldExceeded.setValidators([
            Validators.requiredTrue
          ]);
          this.addOnFrmGroup.controls.isWindshieldExceeded.updateValueAndValidity();
        }
      }
      this.selectedAddOn.push(value);
    } else {
      if (value.code === "EHailing") {
        this.toggleAddonPlanCard("block", "roadTaxRenewalClass");
      }
      let index = this.selectedAddOn.findIndex((x) => x.id == value.id);
      if (index >= 0) {
        this.selectedAddOn.splice(index, 1);
      }
      if (value.category === "Windshield") {
        this.addOnFrmGroup.controls.windshield.setValue(
          this.getMinMaxWindscreenPrice(value, "min")
        );

        if (
          (this.selectedQuotation.code == "Zurich" ||
            this.selectedQuotation.code == "Zurich_Takaful") &&
          !this.requestData.isCompany
        ) {
          this.addOnFrmGroup.controls.isWindshieldExceeded.setValidators([]);
        }
        this.addOnFrmGroup.controls.isWindshieldExceeded.updateValueAndValidity();
      }
      if (value.category === "CART") {
        this.selectedCartDays = this.cartDayList[0].codeValue;
        this.selectedCartDailyCoverage =
          this.cartDailyCoverageList[0].codeValue;
        this.addOnFrmGroup.controls.cartDays.setValue(this.selectedCartDays);
        this.addOnFrmGroup.controls.cartDailyCoverage.setValue(
          this.selectedCartDailyCoverage
        );
      }
      if (value.category === "GCKT") {
        this.addOnFrmGroup.controls.gckt.setValue(this.minGCKTCoverage);
      }
      if (value.category === "VA") {
        this.addOnFrmGroup.controls.va.setValue(this.minVACoverage);
      }
    }
    if (value.category == "Drivers") {
      let frmArray = this.getFormArray();
      frmArray.reset();
      frmArray.clear();
      if (e.checked && value.code == "AdditionalDrivers") this.addDriver();
    }
    this.clearPromoCode();
  }

  paymentTypeChange(paymentType: string) {
    this.selectedPayment = paymentType;
  }

  radioChange(e: ProductAddOnInterface, isCheckbox: boolean = false) {
    let index = this.selectedAddOn.findIndex((x) => x.category == e.category);
    if (index >= 0) this.selectedAddOn.splice(index, 1);
    if (!isCheckbox || index == -1) {
      this.selectedAddOn.push(e);
    }

    let frmArray = this.getFormArray();
    if (frmArray.length == 0 && e.code == "AdditionalDrivers") this.addDriver();
    else {
      frmArray.reset();
      frmArray.clear();
    }
  }

  toggleRoadTax(e: MatCheckboxChange) {
    let value: any = e.source.value as any;
    if (e.checked) {
      this.toggleAddonPlanCard("none", "EHailing");
      this.showRoadTaxList = true;
      this.isIncludeDigitalRoadtax = true;
    }
    if (
      !this.requestData.isMalaysian ||
      this.requestData.isCompany ||
      !e.checked
    ) {
      this.showRoadTaxList = false;
      this.isIncludeDigitalRoadtax = false;
      this.addOnFrmGroup.controls.roadTaxPrice.setValue(
        this.requestData.originalRoadTaxPrice
      );
    }
    if (!e.checked) this.toggleAddonPlanCard("flex", "EHailing");
    this.clearPromoCode();
  }

  toggleAddonPlanCard(display: string, className: string) {
    const elements = document.getElementsByClassName(className);
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = display;
    }
    if (display === "none") {
      if (className === "roadTaxRenewalClass") {
        this.callToggleRoadTax(false);
      } else {
        this.selectedAddOn = this.selectedAddOn.filter(
          (x) => x.category !== className
        );
      }
    }
    this.clearPromoCode();
  }

  callToggleRoadTax(checked: boolean) {
    const event: MatCheckboxChange = {
      checked: checked,
      source: {
        value: "RoadTaxCheckbox"
      } as any
    };
    this.toggleRoadTax(event);
  }

  isRoadTaxSelected(item: any) {
    if (item) {
      return (this.showRoadTaxList = true);
    }
    return (this.showRoadTaxList = false);
  }

  radioDigitalRoadTaxChange(e: any, isChecked: boolean = false) {
    if (e.value == undefined) {
      this.isIncludeDigitalRoadtax = true;
      this.addOnFrmGroup.controls.roadTaxPrice.setValue(
        this.requestData.originalRoadTaxPrice
      );
    } else {
      this.isIncludeDigitalRoadtax = false;
      this.addOnFrmGroup.controls.roadTaxPrice.setValue(
        this.requestData.originalRoadTaxPrice + 15
      );
    }
  }

  getRule(e: ProductAddOnInterface) {
    if (e.rules) {
      return JSON.parse(e.rules);
    }
    return null;
  }

  hasSelectedCode(val: string) {
    return this.selectedAddOn.some((x) => x.code == val);
  }

  hasSelectedCategory(val: string) {
    return this.selectedAddOn.some((x) => x.category == val);
  }

  // -- Not used anymore at #freeDriverText
  // getConditionMax(e: ProductAddOnInterface) {
  //   if (e.code != 'AdditionalDrivers' || !e.condition) return 0;
  //   let count = 1;
  //   for (let index = 1; index < 9999; index++) {
  //     let condition = e.condition.replace('{val}', index.toString());
  //     let status = Boolean(eval(condition));
  //     if (status) {
  //       count = index - 1;
  //       break;
  //     }
  //   }
  //   return count;
  // }

  getInsuredAgeLoadingPrice() {
    let price = 0;
    price =
      this.selectedQuotation?.insuredAgeLoading * this.selectedQuotation?.basePremium;
    return price;
  }

  getAfterLoadingPrice() {
    let price = 0;
    price =
      this.selectedQuotation?.totalBasePremium +
      this.getInsuredAgeLoadingPrice();
    return price;
  }

  // only for motorcycle partners
  getNcdPrice() {
    let price = 0;

    const quotation = this.quotationList.find((q) => q.code === "TMIM");
    if (quotation) {
      return quotation.ncd;
    } else {
      if (this.selectedQuotation?.code.toLowerCase() === 'rhb') {
        price = this.getAfterLoadingPrice() * this.requestData?.ncd;
      } else {
        price =
          this.requestData?.ncd * this.selectedQuotation?.totalBasePremium;
      }
      return Number(price.toFixed(2));
    }
  }

  getGrossPremium() {
    if (!this.requestData && !this.selectedQuotation) return 0;

    let totalGrossPremium = 0;
    if (this.isMotorcycleAffiliate) {
      if (this.selectedQuotation?.code.toLowerCase() === 'rhb') {
        totalGrossPremium = this.getAfterLoadingPrice() - this.getNcdPrice();
      } else {
        totalGrossPremium =
          this.selectedQuotation?.totalBasePremium - this.getNcdPrice();
      }
    } else {
      totalGrossPremium =
        this.selectedQuotation?.totalBasePremium + this.getTotalAddOnPrice();
    }

    if (totalGrossPremium < 0) totalGrossPremium = 0;
    return totalGrossPremium;
  }

  getTotalAddOnPrice() {
    let total = 0;

    this.selectedAddOn.forEach((x) => {
      if (x.code == "AdditionalDrivers")
        total += this.getPrice(x, this.getFormArray().length);
      else if (x.code === "UnlimitedDrivers")
        total += this.getPrice(x, x.evaluate);
      else if (x.category == "Windshield")
        total += this.getPrice(x, this.addOnFrmGroup.value.windshield);
      else if (x.category == "LLTP")
        total += this.getPrice(x, this.numberOfLltpSeats);
      else if (x.category == "MERW") {
        if (this.addOnFrmGroup.value.merw) {
          total += this.addOnFrmGroup.value.merw;
        } else {
          total += this.getPrice(x, "0");
        }
      } else if (x.category == "GCKT")
        total += this.getPrice(x, this.addOnFrmGroup.value.gckt);
      else if (x.category == "VA")
        total += this.getPrice(x, this.addOnFrmGroup.value.va);
      else total += this.getPrice(x);
    });
    return total;
  }

  getTax() {
    if (!this.selectedQuotation) return 0;
    let total = this.getGrossPremium();

    return total * this.selectedQuotation.taxRate;
  }

  getTotalNetPremium() {
    var total =
      Number(this.getGrossPremium().toFixed(2)) +
      Number(this.getTax().toFixed(2)) +
      this.selectedQuotation?.stampDutyPrice;
    total =
      this.selectedQuotation &&
      this.selectedQuotation.code.toLowerCase() === "takaful_malaysia"
        ? CommonFunction.customSTMBRound(total)
        : total;

    return total;
  }

  getPlatformDiscountRate() {
    return (
      this.selectedQuotation?.platformDiscountRate * this.getGrossPremium()
    );
  }

  getTotalPromo() {
    if (!this.promo) return 0;

    let evaluate = this.promo.evaluate;
    evaluate = evaluate.replace(
      "{TotalGrossPremium}",
      this.getGrossPremium().toString()
    );
    return Number.parseFloat(eval(evaluate));
  }

  getPremium() {
    // Total without serviceFee
    let totalBeforeCharges = this.getTotalCharge() - this.getTotalPromo();
    return totalBeforeCharges;
  }

  getShopbackInstalmentCharges() {
    let charges = (1.5 / 100) * this.getPremium();
    return charges;
  }

  getBankInstalmentCharges() {
    return this.getPremium() * this.getEppRate();
  }

  getBNPLCharges() {
    // return the BNPL Service Tax Rate
    //  - Total Service Tax Rate - Portal Service Tax Rate = BNPL Service Tax Rate
    let paymentProvider = this.paymentFormGroup?.value?.paymentProvider;
    const bnplRate = this.bnplRateList?.filter(
      (entry) => entry.paymentMethod == paymentProvider
    );
    if (bnplRate.length > 0) {
      let bnplServiceTaxRate =
        (bnplRate[0].isSubsidized && !this.promo) ||
        (bnplRate[0].isSubsidized && this.promo && bnplRate[0].isAllowPromoCode)
          ? 0
          : bnplRate[0].totalServiceTaxRate -
            this.selectedQuotation.serviceTaxRate;
      let bnplServiceFee =
        bnplServiceTaxRate * (this.getTotalCharge() - this.getTotalPromo());
      return Number(bnplServiceFee.toFixed(2));
    } else {
      return 0;
    }
  }

  getFinalTotalBeforeCharges() {
    // Total with serviceFee, without instalmentCharges
    const total = 
      this.getTotalCharge() -
      this.getTotalPromo() +
      this.getServiceFee() +
      this.getBNPLCharges();

    return Math.max(0, total);
  }

  getTotalCharge() {
    let total = this.getTotalNetPremium() - this.getPlatformDiscountRate();

    if (this.addOnFrmGroup.value?.isIncludeRoadtax) {
        total += this.requestData.originalRoadTaxPrice;

        // If digital road tax is not selected, add delivery price
        if (!this.isIncludeDigitalRoadtax) {
            total += this.requestData.roadTaxDeliveryPrice;
        }
    }

    return Math.max(total, 0);
  }

  getServiceFee() {
    if (!this.selectedQuotation) return 0;

    //Requested by Siew Wai to increase the Service Fee rate by 0.2% if Digital Road Tax is selected. (Removed for now)
    //const digiRoadTaxServiceFeeRateIncrease = 0.002;
    //let serviceFeeDigital  = (this.selectedQuotation.serviceTaxRate + digiRoadTaxServiceFeeRateIncrease) * (this.getTotalCharge() - this.getTotalPromo())
    let serviceFee =
      this.selectedQuotation.serviceTaxRate *
      (this.getTotalCharge() - this.getTotalPromo());

    if (
      this.isPaymentChannelFPX &&
      (this.partnerCode === "carsome" ||
        this.partnerCode === "wapcar" ||
        this.partnerCode === "carlist")
    ) {
      serviceFee = 1;
      return Number(serviceFee.toFixed(2));
    } else {
      // if (this.isIncludeDigitalRoadtax) {
      // 	return Number(serviceFeeDigital.toFixed(2));
      // } else {
      return Number(serviceFee.toFixed(2));
      //}
    }
  }

  getTotal() {
    let totalBeforeCharges =
      this.getTotalCharge() +
      this.getServiceFee() +
      this.getBNPLCharges() -
      this.getTotalPromo();

    if (this.isPaymentTypeEPP) {
      return Math.max(totalBeforeCharges + this.getBankInstalmentCharges(), 0);
    } else {
      // If not shopback
      return Math.max(totalBeforeCharges, 0);
    }
  }

  getPaymentDurationLabel() {
    let paymentFGroup = this.paymentFormGroup?.value;
    if (paymentFGroup?.paymentType == this.paymentOptionEPP) {
      if (paymentFGroup?.installmentMonth == 3) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getTotal() / 3,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for3months")}`;
      } else if (paymentFGroup?.installmentMonth == 6) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getTotal() / 6,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for6months")}`;
      } else if (paymentFGroup?.installmentMonth == 12) {
        return `<span class='bold'>RM ${this._decimalPipe.transform(
          this.getTotal() / 12,
          "1.2-2"
        )}</span>
				${this.translate.instant("common.perMonth")}
				${this.translate.instant("paymentOptions.for12months")}`;
      }
    }
    return "";
  }

  getIdentityNoLabel() {
    if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
      return "common.icNo";
    else if (!this.requestData?.isMalaysian) return "common.passport";
    return "common.businessRegistrationNo";
  }

  getNameLabel() {
    if (this.requestData?.isMalaysian && !this.requestData?.isCompany)
      return "common.namePerIc";
    else if (!this.requestData?.isMalaysian) return "common.namePerPassport";
    return "common.companyName";
  }

  isAddressValid() {
    return !(
      this.infoFrmGroup.controls.address.invalid ||
      this.infoFrmGroup.controls.address2.invalid ||
      this.infoFrmGroup.controls.city.invalid ||
      this.infoFrmGroup.controls.state.invalid
    );
  }

  isSameAddressChecked() {
    if (!this.isAddressValid()) {
      return false;
    }
    let value = this.infoFrmGroup.getRawValue();
    let addr = `${value.address || ""}${value.address2 || ""}${
      value.city || ""
    }${value.postcode || ""}${value.state || ""}`;
    let deliveryAddr = `${value.deliveryAddress || ""}${
      value.deliveryAddress2 || ""
    }${value.deliveryCity || ""}${value.deliveryPostcode || ""}${
      value.deliveryState || ""
    }`;
    return addr == deliveryAddr;
  }

  addressIsChecked(e: MatCheckboxChange) {
    this.isSameAddressCheck = e.checked;
    let validatorList = e.checked ? [] : [Validators.required];
    if (!e.checked) {
      this.infoFrmGroup.controls.deliveryAddress.reset();
      this.infoFrmGroup.controls.deliveryAddress2.reset();
      this.infoFrmGroup.controls.deliveryCity.reset();
      this.infoFrmGroup.controls.deliveryPostcode.reset();
      this.infoFrmGroup.controls.deliveryState.reset();
    }

    this.infoFrmGroup.controls.deliveryAddress.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryAddress2.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryCity.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryPostcode.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryState.setValidators(validatorList);

    this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
  }

  differentAddressIsChecked(e: MatCheckboxChange) {
    this.isDifferentAddressCheck = e.checked;
    let validatorList = e.checked ? [Validators.required] : [];

    if (e.checked) {
      this.infoFrmGroup.controls.deliveryAddress.reset();
      this.infoFrmGroup.controls.deliveryAddress2.reset();
      this.infoFrmGroup.controls.deliveryCity.reset();
      this.infoFrmGroup.controls.deliveryPostcode.reset();
      this.infoFrmGroup.controls.deliveryState.reset();
    }

    this.infoFrmGroup.controls.deliveryAddress.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryAddress2.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryCity.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryPostcode.setValidators(validatorList);
    this.infoFrmGroup.controls.deliveryState.setValidators(validatorList);

    this.infoFrmGroup.controls.deliveryAddress.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryAddress2.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryCity.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryPostcode.updateValueAndValidity();
    this.infoFrmGroup.controls.deliveryState.updateValueAndValidity();
  }

  submit() {
    this.router.navigate([], {
      queryParams: {
        id: this.quotationId,
        pay: true
      }
    });
    this.ngxSpinnerService.show();
    this.motorDataDataService
      .generatePayment(this.id, this.buildGeneratePaymentFormData())
      .subscribe({
        next: (x) => {
          if (x.redirectUrl) {
            window.location.href = x.redirectUrl;
          } else {
            let navigationExtras: NavigationExtras = {
              queryParams: {
                id: x.id,
                partnerCode: this.partnerCode
              }
            };
            this.ngxSpinnerService.hide();
            this.router.navigate(["/payment"], navigationExtras);
          }
        },
        error: (err) => {
          this.alertService.openSnackBar(err.error);
          this.ngxSpinnerService.hide();
        }
      });
  }

  private buildGeneratePaymentFormData(): FormData {
    const {
      windshield,
      drivers,
      isIncludeRoadtax,
      merw,
      lltpSeats,
      cartDays,
      cartDailyCoverage,
      gckt,
      va
    } = this.addOnFrmGroup.value;
    const {
      occupation,
      address,
      address2,
      city,
      state,
      deliveryAddress,
      deliveryAddress2,
      deliveryCity,
      deliveryPostcode,
      deliveryState,
      name,
      email,
      mobileNo,
      mileage
    } = this.infoFrmGroup.value;
    const formData = new FormData();

    formData.append("quotationId", this.quotationId);
    if (windshield) {
      formData.append("windShield", windshield);
    }
    drivers?.forEach((driver, index) => {
      const {
        dob,
        gender,
        idType,
        identityNo,
        maritalStatus,
        name,
        relationship,
        isMalaysian
      } = driver;
      formData.append(
        `additionalDriverList[${index}].Dob`,
        (<Date>dob)?.toISOString() || ""
      );
      formData.append(`additionalDriverList[${index}].Gender`, gender);
      formData.append(`additionalDriverList[${index}].IdType`, idType);
      formData.append(`additionalDriverList[${index}].IdentityNo`, identityNo);
      formData.append(
        `additionalDriverList[${index}].MaritalStatus`,
        maritalStatus
      );
      formData.append(`additionalDriverList[${index}].Name`, name);
      formData.append(
        `additionalDriverList[${index}].Relationship`,
        relationship
      );
      formData.append(
        `additionalDriverList[${index}].IsMalaysian`,
        isMalaysian
      );
    });
    this.selectedAddOn.forEach((addOn, index) => {
      formData.append(`addOnIds[${index}]`, addOn.id);
    });
    formData.append("occupation", occupation);
    formData.append("address", address);
    formData.append("address2", address2);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("deliveryAddress", deliveryAddress || address);
    formData.append("deliveryAddress2", deliveryAddress2 || address2);
    formData.append("deliveryCity", deliveryCity || city);
    formData.append(
      "deliveryPostcode",
      deliveryPostcode || this.requestData?.postcode
    );
    formData.append("deliveryState", deliveryState || state);
    formData.append("includeRoadTax", isIncludeRoadtax ?? false);
    formData.append("includeDigitalRoadTax", `${this.isIncludeDigitalRoadtax}`);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobileNo", mobileNo);
    formData.append("seat", this.isMotorcycleAffiliate ? 1 : lltpSeats ?? "");

    if (this.partnerCode === "ktmb") {
      this.buildMileagePhotoFormData(formData);
    }
    this.buildPaymentFormData(formData);

    if (merw) {
      formData.append("merw", merw);
    }

    if (mileage !== null) {
      formData.append("mileage", mileage);
    }

    if (this.promo?.id) {
      formData.append("promoCodeId", this.promo?.id);
    }

    if (cartDays) {
      formData.append("cartDays", cartDays);
    }

    if (cartDailyCoverage) {
      formData.append("cartDailyCoverage", cartDailyCoverage);
    }

    if (gckt) {
      formData.append("gckt", gckt);
    }

    if (va) {
      formData.append("va", va);
    }

    return formData;
  }

  private buildPaymentFormData(formData: FormData): void {
    let paymentFGroup = this.paymentFormGroup?.value;
    // To change payment channel for e-wallet and EPP
    if (paymentFGroup?.paymentChannel == this.paymentOptionEwallet)
      paymentFGroup.paymentChannel = this.paymentFormGroup?.value?.ewalletType;
    if (paymentFGroup?.paymentType == this.paymentOptionEPP)
      paymentFGroup.paymentChannel = this.paymentFormGroup?.value?.bank;
    // To change payment type null for shopback
    if (paymentFGroup?.paymentProvider == this.paymentOptionShopback)
      paymentFGroup.paymentType = null;

    formData.append(
      "paymentProvider",
      this.paymentFormGroup?.value?.paymentProvider || this.paymentOptionRazer
    );
    formData.append(
      "paymentType",
      paymentFGroup.paymentType || this.paymentOptionFullPrice
    );
    formData.append(
      "paymentChannel",
      paymentFGroup.paymentChannel || this.paymentOptionVisa
    );

    if (this.paymentFormGroup?.value?.installmentMonth) {
      formData.append(
        "installmentMonth",
        this.paymentFormGroup?.value?.installmentMonth
      );
    }
  }

  private buildMileagePhotoFormData(formData: FormData): void {
    const { mileagePhoto } = this.infoFrmGroup.value;

    formData.append(`kTMBFileLists[0].type`, "Mileage");
    for (const file of mileagePhoto) {
      formData.append(`kTMBFileLists[0].files`, file);
    }
  }

  getFormArrayControlError(i, formControlName) {
    return (this.getFormArray().controls[i] as FormGroup).controls[
      formControlName
    ].errors;
  }

  benefitDialog(item) {
    this.dialog.open(BenefitDialogComponent, {
      panelClass: "benefit-dialog",
      data: {
        productId: item.productId,
        code: item.code,
        lang: this.translate.currentLang,
        insuranceType: this.requestData.insuranceType
      }
    });
  }

  getAddOnCode(code) {
    return `addOn.${code}`;
  }

  hasAddOn() {
    return (
      this.selectedAddOn.filter(
        (x) => !x.hidePriceBreakdown && x.code != "AllRiders"
      ).length != 0
    );
  }

  addonLabel(value: number) {
    return "RM " + value.toFixed(2).toLocaleString();
  }

  filterRecommendedAddOns() {
    this.addOnList = this.addOnList.filter(
      (x) => x.category == "Flood" || x.category == "Windshield"
    );
    if (!this.requestData.eHailingUsed) {
      this.addOnFrmGroup.controls.isIncludeRoadtax.setValue(true);
      this.isIncludeDigitalRoadtax = true;
    }
  }

  toggleRecommendedAddOns(boolean: any) {
    this.toggleRecommendedAddOnsState = boolean;

    if (boolean) {
      this.getAddOn();
      this.isIncludeDigitalRoadtax = true;
    }
    if (!boolean) {
      this.getAddOn();
      this.addOnFrmGroup.controls.isIncludeRoadtax.setValue(false);
      this.isIncludeDigitalRoadtax = false;
      this.selectedAddOn.splice(
        this.selectedAddOn.findIndex((x) => x.category === "Flood"),
        1
      );
      this.selectedAddOn.splice(
        this.selectedAddOn.findIndex((x) => x.category === "Windshield"),
        1
      );
    }
  }

  openCarVariantDialog(id: string) {
    let dialogRef = this.dialog.open(CarVariantDialogComponent, {
      panelClass: "edit-car-variant-dialog",
      data: {
        requestData: this.requestData,
        linkId: this.id,
        cssClass: this.partnerCode === "ktmb" ? "ktmb-banner" : "",
        isMotorcycle: this.isMotorcycleAffiliate
      },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.data === true) {
        this.selectQuotation(id);
      }
    });
  }

  backToStep(index: number) {
    this.stepper.selectedIndex = index;
  }

  get insurerFullName(): string {
    if (this.selectedQuotation && this.selectedQuotation.code) {
      return INSURER_FULL_NAME[this.selectedQuotation.code];
    }
    return "";
  }

  getPSComissionPrice() {
    // PS comission, only shown in Allianz quote in order summary section
    let comission = this.getGrossPremium() * (10 / 100);
    return Number(comission.toFixed(2));
  }

  getAgreementLinks(): Record<string, string> {
    switch (this.selectedQuotation?.code?.toUpperCase()) {
      case "MSIG":
        return {
          pds: "https://storage.googleapis.com/ps-asset/motor/policy_docs/MSIG%2BEZ-Mile%2BPDS.pdf",
          faq: "https://storage.googleapis.com/ps-asset/motor/policy_docs/EZ-Mile%2BFAQ%2B(ENG).pdf"
        };
      case "RHB":
        return {
          pds: "https://storage.googleapis.com/ps-asset/motor/policy_docs/Private_Car_PDS_M_PCP.pdf",
          faq: "https://storage.googleapis.com/ps-asset/motor/policy_docs/RHBI_Motor%20Saver_FAQ.pdf"
        };
      case "SOMPO":
        return {
          pds: "https://storage.googleapis.com/ps-asset/motor/policy_docs/SOMPO%20MotorSafe%20PDS.pdf",
          faq: "https://storage.googleapis.com/ps-asset/motor/policy_docs/SOMPO%20MotorSafe%20FAQ%20(EN).pdf"
        };
      default:
        return {
          pds: "",
          faq: ""
        };
    }
  }

  getMinMaxWindscreenPrice(
    addOn: ProductAddOnInterface,
    key: "min" | "max"
  ): number {
    const rule = this.getRule(addOn);
    const { maxWindshieldPrice, minWindshieldPrice } = this.selectedQuotation;

    const config = {
      max: maxWindshieldPrice || rule?.max || 10000,
      min: minWindshieldPrice || rule?.min || 500
    };

    return config[key];
  }

  showGeneraliPaymentConfirmation() {
    this.isShowGeneraliPaymentConfirmation = true;
  }

  hideGeneraliPaymentConfirmation() {
    this.isShowGeneraliPaymentConfirmation = false;
  }

  allCheckboxesChecked(): boolean {
    return this.generaliAgreeInfoOne && this.generaliAgreeInfoTwo;
  }

  private getCARTAddOnPriceList() {
    this.motorDataDataService.getCARTAddOnPriceList().subscribe({
      next: (x: MotorAddOnCARTPriceInterface[]) => {
        this.cartAddOnPriceList = x;
      }
    });
  }

  get isGrabPartner(): boolean {
    return this.partnerCode === "grab";
  }

  get isDailyAnnualOrAnnual(): boolean {
    return (
      this.dailyAndAnnual.includes(this.selectedQuotation?.code) ||
      this.annualOnly.includes(this.selectedQuotation?.code)
    );
  }

  get isDailyOrDailyAnnual(): boolean {
    return (
      this.dailyAndAnnual.includes(this.selectedQuotation?.code) ||
      this.dailyOnly.includes(this.selectedQuotation?.code)
    );
  }
}
